import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import './styles.css'

const ContextMenu = ({ position, items, onClose, topBarContent, bounds }) => {
    const menuRef = useRef(null);
    const containerRef = useRef(null);
    const [adjustedPosition, setAdjustedPosition] = useState(position);

    useLayoutEffect(() => {
        if (!containerRef.current) return;

        const menu = containerRef.current;
        const boundary = bounds || {
            top: 0,
            left: 0,
            right: window.innerWidth,
            bottom: window.innerHeight
        };
        const inset = 8;
        const minX = boundary.left + inset;
        const minY = boundary.top + inset;
        const maxX = boundary.right - menu.offsetWidth - inset;
        const maxY = boundary.bottom - menu.offsetHeight - inset;

        setAdjustedPosition({
            x: Math.max(minX, Math.min(position.x, Math.max(minX, maxX))),
            y: Math.max(minY, Math.min(position.y, Math.max(minY, maxY)))
        });
    }, [position.x, position.y, bounds, items.length, topBarContent]);

    useEffect(() => {
        const handleClickOutside = (e) => {
            if (containerRef.current && !containerRef.current.contains(e.target)) {
                onClose();
            }
        };
        document.addEventListener('click', handleClickOutside);
        document.addEventListener('contextmenu', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
            document.removeEventListener('contextmenu', handleClickOutside);
        };
    }, [onClose]);

    return (
        <div
            ref={containerRef}
            className="context-menu-wrapper"
            style={{
                top: adjustedPosition.y,
                left: adjustedPosition.x
            }}
        >
            {topBarContent && (
                <div className="context-menu-topbar">
                    {topBarContent}
                </div>
            )}

            <ul
                ref={menuRef}
                className="context-menu"
            >
                {items.map(({ key, label, icon, onClick, isDivider, disabled, danger }) => {
                    if (isDivider) {
                        return (
                            <hr
                                key={key}
                                className="context-menu-divider"
                            />
                        );
                    }
                    return (
                        <li
                            key={key}
                            onClick={(e) => {
                                if (disabled) return;
                                onClick(e);
                            }}
                            className={`context-menu-item ${disabled ? 'disabled' : ''} ${danger ? 'danger' : ''}`}
                        >
                            <span className="context-menu-item__icon">
                                {typeof icon === 'string' && (
                                    <img src={icon} alt={key} width={16} height={16} />
                                )}
                                {typeof icon !== 'string' && icon}
                            </span>
                            <span className="context-menu-item__label">{label}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

ContextMenu.propTypes = {
    position: PropTypes.shape({
        x: PropTypes.number.isRequired,
        y: PropTypes.number.isRequired
    }).isRequired,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            label: PropTypes.node,
            icon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
            onClick: PropTypes.func,
            isDivider: PropTypes.bool,
            disabled: PropTypes.bool,
            danger: PropTypes.bool
        })
    ).isRequired,
    onClose: PropTypes.func.isRequired,
    topBarContent: PropTypes.node,
    bounds: PropTypes.shape({
        top: PropTypes.number.isRequired,
        right: PropTypes.number.isRequired,
        bottom: PropTypes.number.isRequired,
        left: PropTypes.number.isRequired
    })
};

export default ContextMenu;



// WEBPACK FOOTER //
// ./src/components-new/ui/ContextMenu/index.jsx